import blog1 from "../../assets/images/one.png";
import blog2 from "../../assets/images/two.png";
import blog3 from "../../assets/images/three1.png";
import blog4 from "../../assets/images/four.png";
import blog6 from "../../assets/images/six.png";
import blog7 from "../../assets/images/seven.png";
import blog8 from "../../assets/images/eigth.png";
import blog9 from "../../assets/images/nine.png";

export const articles = [
  {
    slug: "bolgesel-incelme-nasil-calisir",
    title: "Bölgesel İncelme Nasıl Çalışır?",
    content: `
      <p>Bölgesel incelme uygulamaları, vücudun belirli bölgelerindeki yağ dokusunu hedef alarak sıkılaşma ve şekillendirme sağlayan profesyonel yöntemlerdir.</p>
      <h3>Kimler İçin Uygundur?</h3>
      <p>Genel kilosu normal olmasına rağmen bölgesel yağlanma yaşayan bireyler için idealdir. Doğum sonrası vücut şekillendirme veya selülit görünümünü azaltmak isteyenler için de etkili sonuçlar sunar.</p>
      <h3>Hangi Teknolojiler Kullanılır?</h3>
      <ul>
        <li><strong>EmShape:</strong> Yüksek yoğunluklu elektromanyetik enerjiyle kas stimülasyonu ve yağ yakımı sağlar.</li>
        <li><strong>G5 Masajı:</strong> Mekanik titreşimlerle derin dokuya etki eder, selülit görünümünü azaltır.</li>
        <li><strong>Lenf Drenaj:</strong> Ödem ve toksinleri atarak dolaşımı hızlandırır.</li>
        <li><strong>Ozon Sauna:</strong> Deri altı dolaşımını destekler, detoks sağlar.</li>
      </ul>
      <h3>Kaç Seans Gerekir?</h3>
      <p>Ortalama 8–12 seans ile belirgin fark gözlemlenir. Kişiye özel program ve düzenli bakımla sonuçlar kalıcı hâle gelir.</p>
      <p>Sanethica olarak her müşterimiz için özel protokol oluşturuyor, süreci yakından takip ediyoruz.</p>
    `,
    image: blog1,
  },
  {
    slug: "emshape-nedir",
    title: "EmShape Nedir? Kimler İçin Uygundur?",
    content: `
      <p>EmShape, yüksek yoğunluklu elektromanyetik enerji kullanarak kasları güçlendiren ve yağ dokusunu azaltan gelişmiş bir estetik cihazdır.</p>
      <h3>Nasıl Çalışır?</h3>
      <p>Cihaz, tek bir seansta binlerce kas kasılmasına eşdeğer uyarım sağlar. Bu sayede kas kütlesi artarken bölgesel yağ oranı düşer. Seans süresince herhangi bir ağrı hissedilmez.</p>
      <h3>Hangi Bölgelere Uygulanır?</h3>
      <ul>
        <li>Karın ve bel bölgesi sıkılaştırma</li>
        <li>Kalça kaldırma ve şekillendirme</li>
        <li>Bacak ve uyluk bölgesi</li>
        <li>Kol sıkılaştırma</li>
      </ul>
      <h3>Kaç Seans Önerilir?</h3>
      <p>Genellikle haftada 2 seans, toplam 4–8 seans program olarak planlanır. Sonuçlar 2–4 hafta içinde belirginleşmeye başlar.</p>
      <p>Sanethica'da EmShape seansları profesyonel gözetiminde, kişiye özel program dahilinde uygulanmaktadır.</p>
    `,
    image: blog2,
  },
  {
    slug: "lenf-drenaj-faydalari",
    title: "Lenf Drenaj Masajının Faydaları",
    content: `
      <p>Lenf drenaj masajı, lenf sistemini uyararak vücuttaki fazla sıvının ve toksinlerin atılmasına yardımcı olan özel bir masaj tekniğidir.</p>
      <h3>Faydaları Nelerdir?</h3>
      <ul>
        <li>Ödem ve şişliği hızla azaltır</li>
        <li>Dolaşımı canlandırır</li>
        <li>Bağışıklık sistemini destekler</li>
        <li>Selülit görünümünü iyileştirir</li>
        <li>Genel yorgunluk ve ağırlık hissini giderir</li>
      </ul>
      <h3>Kimler Tercih Etmeli?</h3>
      <ul>
        <li>Bacak ve ayak ödemi yaşayanlar</li>
        <li>Estetik operasyon sonrası iyileşme sürecindekiler</li>
        <li>Lipödem veya lenfödem tanısı olanlar</li>
        <li>Yoğun tempolu yaşam nedeniyle kronik yorgunluk hissedenleri</li>
      </ul>
      <h3>Ne Sıklıkla Yapılmalı?</h3>
      <p>Haftada 1–2 seans, düzenli uygulamayla en etkin sonuçlar elde edilir. Sanethica'da deneyimli terapistlerimiz, vücut analizinize göre lenf drenaj protokolünüzü belirler.</p>
    `,
    image: blog3,
  },
  {
    slug: "selulit-ile-bas-etme",
    title: "Selülitle Baş Etmenin Etkili Yolları",
    content: `
      <p>Selülit, yağ dokusunun deri altında birikmesiyle oluşan ve pek çok kadında görülen yaygın bir estetik sorundur. Genetik, hormonal değişimler ve hareketsiz yaşam tarzı en önemli etkenler arasındadır.</p>
      <h3>Hangi Uygulamalar Etkilidir?</h3>
      <ul>
        <li><strong>G5 Mekanik Masaj:</strong> Doku sıkılaştırma ve kan dolaşımını artırma</li>
        <li><strong>Lenf Drenaj:</strong> Toksin atımı ve ödem giderme</li>
        <li><strong>EmShape:</strong> Derin kas çalıştırma ve bölgesel yağ azaltma</li>
        <li><strong>Ozon Sauna:</strong> Deri altı dolaşım desteği ve arınma</li>
      </ul>
      <h3>Kalıcı Sonuç İçin Ne Yapılmalı?</h3>
      <p>Düzenli seans programı ve aktif yaşam tarzı kombinasyonu, selülit görünümünü belirgin şekilde azaltır. Tek seferlik uygulamalardan ziyade düzenli bakım protokolü çok daha etkilidir.</p>
      <p>Sanethica'da profesyonellerimiz vücut analizinize göre size özel selülit tedavi protokolü belirler.</p>
    `,
    image: blog4,
  },

  {
    slug: "masaj-turleri",
    title: "Masaj Türleri ve Faydaları",
    content: `
      <p>Masaj, kas ve doku gerginliğini gidererek kan dolaşımını artıran, hem bedensel hem zihinsel iyilik hâlini destekleyen köklü bir terapi yöntemidir.</p>
      <h3>Sanethica'da Uygulanan Masaj Türleri</h3>
      <ul>
        <li><strong>Lenfödem Masajı:</strong> Lenf sistemini uyararak ödem ve şişliği azaltır.</li>
        <li><strong>Lipödem Masajı:</strong> Yağ dokusundaki anormal birikimi hedef alarak rahatlama sağlar.</li>
        <li><strong>Selülit Masajı:</strong> Deri altı doku yapısını iyileştirerek portakal kabuğu görünümünü azaltır.</li>
      </ul>
      <h3>Masaj Ne Sıklıkla Yapılmalı?</h3>
      <p>Hedef ve vücut tipine göre değişmekle birlikte, haftada 1–2 seans düzenli program en etkin sonuçları verir. İlk seanstan itibaren gevşeme ve hafiflik hissi başlar.</p>
      <p>Sanethica'da tüm masaj uygulamaları deneyimli terapistler tarafından, kişiye özel protokolle yapılmaktadır.</p>
    `,
    image: blog6,
  },
  {
    slug: "ozon-sauna-nedir",
    title: "Ozon Sauna: Detoks ve Dolaşım Desteği",
    content: `
      <p>Ozon sauna, vücudu ozonla zenginleştirilmiş buhar ortamına maruz bırakarak derin arınma, dolaşım desteği ve cilt yenilenmesi sağlayan modern bir wellness uygulamasıdır.</p>
      <h3>Faydaları Nelerdir?</h3>
      <ul>
        <li>Deri altı dolaşımını canlandırır</li>
        <li>Toksin atımını hızlandırır</li>
        <li>Selülit ve ödem görünümünü azaltır</li>
        <li>Cilt dokusunu sıkılaştırır ve parlaklık kazandırır</li>
        <li>Genel enerji düzeyini artırır</li>
      </ul>
      <h3>Kimler Yararlanabilir?</h3>
      <p>Kronik yorgunluk, ödem, bölgesel yağlanma ve cilt sorunları yaşayan bireyler için uygundur. Bölgesel incelme programlarıyla birlikte uygulandığında sonuçları güçlendirir.</p>
      <p>Sanethica'da ozon sauna, kişiye özel wellness programının tamamlayıcı bir parçası olarak uygulanmaktadır.</p>
    `,
    image: blog7,
  },
  {
    slug: "guzellik-rutini-nasil-olusturulur",
    title: "Kişiye Özel Güzellik Rutini Nasıl Oluşturulur?",
    content: `
      <p>Her vücut yapısı, cilt tipi ve yaşam tarzı birbirinden farklıdır. Bu nedenle "herkese uyan tek rutin" diye bir şey yoktur; doğru rutin, sizi tanıyan profesyonellerimiz birlikte şekillenir.</p>
      <h3>Güzellik Rutininin Temel Bileşenleri</h3>
      <ul>
        <li><strong>Cihaz Destekli Uygulamalar:</strong> EmShape, G5, ozon sauna gibi teknolojiler hedefe göre seçilir.</li>
        <li><strong>Masaj Terapisi:</strong> Lenf drenaj veya selülit masajı haftalık programa eklenir.</li>
        <li><strong>Wellness Desteği:</strong> Stres yönetimi ve yaşam tarzı düzenlemeleri rutinin ayrılmaz parçasıdır.</li>
      </ul>
      <h3>Nereden Başlamalı?</h3>
      <p>İlk adım, bir profesyonelle kapsamlı bir ön görüşme yapmaktır. Vücut analizi, hedefleriniz ve mevcut durumunuz değerlendirilerek size özel yol haritası çizilir.</p>
      <p>Sanethica'da ücretsiz ön görüşme ile kişiye özel programınızı birlikte planlıyoruz.</p>
    `,
    image: blog8,
  },
  {
    slug: "estetik-uygulamalarda-sikca-sorulan-sorular",
    title: "Estetik Uygulamalarda Sıkça Sorulan Sorular",
    content: `
      <p>Bölgesel incelme ve wellness uygulamalarına başlamadan önce aklınızdaki soru işaretlerini giderelim.</p>
      <h3>Uygulamalar Ağrılı mıdır?</h3>
      <p>EmShape, lenf drenaj ve G5 gibi uygulamalar konforlu bir şekilde gerçekleştirilir. Seans sırasında hafif basınç veya titreşim hissedilebilir, ancak ağrı yaşanmaz.</p>
      <h3>Sonuçlar Ne Zaman Görülür?</h3>
      <p>Uygulamaya ve kişiye göre değişmekle birlikte, genellikle 3–5 seanstan itibaren ilk değişimler fark edilmeye başlanır.</p>
      <h3>Sonuçlar Kalıcı mıdır?</h3>
      <p>Düzenli bakım ve aktif yaşam tarzıyla sonuçlar uzun süreli olabilir. Profesyonellerimiz size özel idame programı önerir.</p>
      <h3>Kimler Uygulama Yaptırmamalıdır?</h3>
      <ul>
        <li>Hamile bireyler</li>
        <li>Kalp pili kullananlar</li>
        <li>Aktif enfeksiyon bölgesi olanlar</li>
      </ul>
      <p>Her uygulamadan önce profesyonellerimiz kapsamlı bir değerlendirme yaparak size en uygun protokolü belirler.</p>
    `,
    image: blog9,
  },
];
